import BulkReassign from "../Component/BulkReassign";
import { connect } from 'react-redux';
import { getServiceEODReport, rescheduleMultipleServices } from '../../../../Action';
const mapStateToProps = (state) => {
  let { ServiceEODReport } = state
  return {
    ServiceEODReport
  }
}
const actionCreators = {
  getServiceEODReport,
  rescheduleMultipleServices
}
export default (connect(mapStateToProps, actionCreators)(BulkReassign));
